import React from 'react'

export default function Footer() {
    return (
        <div className="footer">
            <span>Built with React and Laravel</span>
        </div>
    )
}
